const initialState = {};

const Reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "SAVE_TaskList":
      return { ...state, List: payload };
    case "SAVE_TaskDetail":
      return { ...state, Detail: payload };
    case "SAVE_TaskComments":
      return { ...state, Comments: payload };
    case "CLEAR":
      return initialState;
    default:
      return state;
  }
};

export default Reducer;
